'use memo';
import { createFileRoute } from '@tanstack/react-router';

import useDocumentTitle from '@/hooks/useDocumentTitle';
import { stacktraceNS, useTranslation } from '@/lib/i18n';

import { ProductAddPage } from './-components/ProductAddPage';

/**
 * プロダクト（Product）新規追加画面 (route 登録)。
 *
 * 本体は `-components/ProductAddPage.tsx` に分離 (playbook §3.18:
 * AttributeCard / Combobox / Grid / useNavigate / useTranslation 等の
 * generic を route 直下 inline すると TanStack Router の型生成が
 * cascade する)。route ファイル側では useDocumentTitle のみ呼び出す。
 *
 * 3 ステップ構成:
 * - Step1 基本情報   (name / objective / code)
 * - Step2 公開設定   (publishStatus / publishScope)
 * - Step3 担当       (ownerPerson)
 */
export const Route = createFileRoute('/_stacktrace/products/add/')({
  component: ProductAddRouteComponent,
});

function ProductAddRouteComponent() {
  const { t } = useTranslation(stacktraceNS, {
    keyPrefix: 'products.add',
  });
  useDocumentTitle(t('documentTitle'));
  return <ProductAddPage />;
}
